export class DeferredClear {
  constructor(clearNow) {
    this.clearNow = clearNow;
    this.updateDepth = 0;
    this.pending = false;
  }

  beginUpdate() {
    this.updateDepth += 1;
  }

  request() {
    if (this.updateDepth > 0) {
      this.pending = true;
      return false;
    }
    this.clearNow();
    return true;
  }

  endUpdate() {
    this.updateDepth = Math.max(0, this.updateDepth - 1);
    if (this.updateDepth > 0 || !this.pending) return false;
    this.pending = false;
    this.clearNow();
    return true;
  }
}
